import { post, put } from '../Services/http';
export const DROPZONE_SET_QUERY = 'DROPZONE_SET_QUERY';
export const DROPZONE_SEARCH = 'DROPZONE_SEARCH';
export const DROPZONE_SUBMIT_ERROR = 'DROPZONE_SUBMIT_ERROR';
export const DROPZONE_SET_ARTICLE_LIST = 'DROPZONE_SET_ARTICLE_LIST';
import { catchError } from './Error.action';

export const mergeArticles = (articles) => (dispatch, getState) => {
    //get old articles from state, make them array (why needed here?)
    var oldArticles = getState().dropZone.articles;
    oldArticles = Object.keys(oldArticles).map((key => oldArticles[key]));
    //Make array of new articles
    var newArticles = Object.keys(articles.items).map((key => articles.items[key]));

    //go through new articles and update quantity or add to list if not exists
    var i;
    for (i = 0; i < newArticles.length; i++) {
        var exists = oldArticles.find(z => z.id == newArticles[i].id);
        if (exists) {
            exists.quantity += newArticles[i].quantity;
        }
        else {
            oldArticles.push(newArticles[i]);
        }
    }
    return oldArticles;
}

export const setArticleList = articles => ({
    type: DROPZONE_SET_ARTICLE_LIST,
    articles: articles
})

export const remove = (id) => (dispatch, getState) => {

    //get old articles from state, make them array (why needed here?)
    var oldArticles = getState().dropZone.articles;
    oldArticles = Object.keys(oldArticles).map((key => oldArticles[key]));

    var removeIndex = oldArticles.map(item => item.id).indexOf(id);
    ~removeIndex && oldArticles.splice(removeIndex, 1);
    return dispatch(setArticleList(oldArticles));
}

export const clearArticleList = () => (dispatch) => {
    return dispatch(setArticleList([]));
}


export const search = (mobile) => (dispatch, getState) => {
    const { payload } = getState().dropZone;
    if (payload.searchItems && payload.searchItems.length > 0) {
        return post('/api/dropzone/search', payload)
            .then(response => response.json())
            .then(articles => dispatch(mergeArticles(articles)))
            .then(articles => dispatch(setArticleList(articles)))
            .then(() => {
                dispatch({
                    type: DROPZONE_SET_QUERY,
                    payload: {
                        searchItems: {}
                    }
                });

                if (mobile) {
                    var els = document.getElementsByClassName('dropzone-quantity-mobile');
                    els[els.length - 1].focus();
                    els[els.length - 1].select();
                }
                else {
                    var els = document.getElementsByClassName('dropzone-quantity-desktop');
                    els[els.length - 1].focus();
                    els[els.length - 1].select();
                }
            })
            .catch(ex => dispatch(catchError(ex, error => submitError(error))))
    }
}

export const setQuantity = (id, q) => (dispatch, getState) => {

    if (!q)
        q = 0;

    var oldArticles = getState().dropZone.articles;
    oldArticles = Object.keys(oldArticles).map((key => oldArticles[key]));

    for (var i = 0; i < oldArticles.length; i++) {
        if (oldArticles[i].id == id) {
            oldArticles[i].quantity = q;
            break;
        }
    }
    return dispatch(setArticleList(oldArticles));
}

export const setQuery = (searchItems) => (dispatch) => {
    dispatch({
        type: DROPZONE_SET_QUERY,
        payload: {
            searchItems: searchItems
        }
    });
}

export const submitError = error => ({
    type: DROPZONE_SUBMIT_ERROR,
    payload: {
        error,
    },
})